import ApiService from '../api.service';
// import { LocaleService } from '../storage.service';

export default {
    async getAHSRequests(itemsPerPage = 10, page = 1) {
        const { data: response } = await ApiService.post('ahs-requests/getAHSRequests', {
            itemsPerPage,
            currentItem: itemsPerPage * (page - 1)
        });
        return response.data;
    },

    async getAHSRequestDetails(request_rid) {
        const { data: response } = await ApiService.get(`ahs-requests/getAHSRequestDetails/?id=${request_rid}`);
        return response.data;
    },

    async getAHSRequestTypes() {
        const { data: response } = await ApiService.get('ahs-requests/getAHSRequestTypes');
        return response.data;
    },

    async getRequestDocuments(params) {
        const { data: response } = await ApiService.get('ahs-requests/getRequestDocuments', { params });

        return response.data.ahs_documents;
    },

    async createAHSRequest(payload) {
        const { data: response } = await ApiService.post('ahs-requests/createAHSRequest', payload);
        return response.data;
    },

    async updateAHSRequest(payload) {
        const { data: response } = await ApiService.post('ahs-requests/updateAHSRequest', payload);
        return response.data;
    },

    async deleteAHSRequest(payload) {
        payload.to_delete = 1;
        const { data: response } = await ApiService.post('ahs-requests/deleteAHSRequest', payload);
        return response.data;
    },

    /** Изменение статуса заявки
     *
     * @param {Int} request_rid
     * @param {int} status_rid
     */
    async updateRequestStatus(request_rid, status_rid) {
        const { data: response } = await ApiService.post('ahs-requests/updateRequestStatus', { request_rid, status_rid });
        return response.data;
    }

    // async addKSKtoHouseBinding(payload) {
    //     const { data: response } = await ApiService.post('ksk/create_ksk_house_period', payload);
    //     return response.data;
    // },

    // async updateKSKtoHouseBinding(id, payload) {
    //     const { data: response } = await ApiService.post(`ksk/update_ksk_house_period/${id}`, payload);
    //     return response.data;
    // },

    // async deleteKSKtoHouseBinding(isas_period_rid) {
    //     const { data: response } = await ApiService.post(`ksk/delete_ksk_house_period`, { isas_period_rid });
    //     return response.data;
    // }
};
